module.exports = __webpack_public_path__ + "img/tfp_logo.07c1ddb2.png";